module.exports = __webpack_public_path__ + "static/media/benefit-decrease-without-rfa.178aad8c.svg";